import Rete from 'rete';

export const sockets = {
  items: new Rete.Socket('Items Array'),
  field_value: new Rete.Socket('Field Value'),
  field_value_deleted_field: new Rete.Socket('Field Value Deleted Field'),
  object: new Rete.Socket('Object Value'),
  instance: new Rete.Socket('Instance'),
}